export const STATSIG_EVENTS = {
  ADD_TO_CART: 'add_to_cart',
  CREATE_TRADE_APPLICATION: 'create_trade_application',
  VISIT_PDP: 'visit_pdp',
  SHOWROOM_PURCHASE: 'showroom_purchase',
  CONSULTATION_PURCHASE: 'consultation_purchase',
  STRAPI_HERO_WIDGET_ACTION: 'strapi_hero_widget_action',
  LEGACY_HERO_WIDGET_ACTION: 'legacy_hero_widget_action',
  STRAPI_BRANDS_WIDGET_ACTION: 'strapi_brands_widget_action',
  STRAPI_CATEGORIES_WIDGET_ACTION: 'strapi_categories_widget_action',
  STRAPI_FEATURED_EXPERTS_WIDGET_ACTION:
    'strapi_featured_experts_widget_action',
  LEGACY_VALUE_PROPOSITION_WIDGET_ACTION:
    'legacy_value_proposition_widget_action',
  LEGACY_EXPERTS_WIDGET_ACTION: 'legacy_experts_widget_action',
  TRADE_PHONE_CALL: 'trade_phone_call',
  ADD_TO_FAVORITES: 'add_to_favorites',
  REMOVE_FROM_FAVORITES: 'remove_from_favorites',
  REPEATABLE_ORDER: 'repeatable_order',
  NO_RESULT_SEARCH_NOTE: 'no_result_search_note',
  QUESTION_OR_CUSTOMIZATION_REQUEST: 'question_or_customization_request',
  SEARCH_INPUT: 'search_input',
  FILTER_DIMENSIONS_DEPTHS: 'filter_dimensions_depths',
  FILTER_DIMENSIONS_HEIGHTS: 'filter_dimensions_heights',
  FILTER_DIMENSIONS_WIDTHS: 'filter_dimensions_widths',
  FILTER_LOCATION_TYPES: 'filter_location_types',
} as const
